/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />
///<reference path="criteria/mi100.criteria.ts"/>
///<reference path="criteria/ma075.criteria.ts"/>


module Meevo.Components.Controls {
    'use strict';

    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import IReportControlScope = Meevo.Plugins.Reports.IReportControlScope;
    import IReportsHelper = Meevo.Plugins.Reports.IReportsHelper;
    import ReportDateRangeBasedOnEnum = Meevo.Model.ReportDateRangeBasedOnEnum;
    import SmartMoverHiddenValue = Meevo.Model.SmartMoverHiddenValue;

    const controlValues: any = {};
    let modelWatcher;

    export class ReportControl implements angular.IDirective {

        /**
         * Get SecurityAccessEnum
         * @returns {any} SecurityAccessEnum
         * */
        get securityAccessEnum(): any {
            return SecurityAccessEnum;
        }

        get objectStateEnum(): any {
            return ObjectStateEnum;
        }

        protected templateBaseUrl: string = 'app/components/controls/reportControl/templates/';


        selectedReport: Meevo.Model.IReportGeneral;
        mainModel: any;
        isRendered = false;

        restrict = 'E';
        template = '';
        scope = {
            options: '=',
            mainModel: '=',
            form: '=form',
            hierarchyForm: '=',
            selectedReport: '=',
            validationJson: '=?',
            startDayOfWeek: '=?',
            disabled: '=?ngDisabled'
        };

        constructor(
            private $compile: angular.ICompileService,
            private $timeout: angular.ITimeoutService,
            private $templateRequest: angular.ITemplateRequestService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected modalService: Meevo.Components.Modal.IModalService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            private reportLogicFactory: IReportLogicFactory,
            private $translate: angular.translate.ITranslateService,
        ) {
        }

        /**
         * Directive's link function
         * @param {IReportControlScope} scope - directive's scope
         * @param {JQuery} element - directive's element
         * */
        link = (scope: IReportControlScope, element: JQuery) => {
            if (!scope.validationJson) {
                scope.validationJson = {};
            }

            if (!modelWatcher) {
                modelWatcher = scope.$watch('mainModel', _.debounce((newValue) => {
                    console.log(newValue);
                }, 500), true);
            }

            scope.isRendered = false;
            scope.parameterNames = [];
            scope.securityAccessEnum = this.securityAccessEnum;
            scope.objectStateEnum = this.objectStateEnum;
            scope.securityAccess = SecurityAccessEnum.Grant; // by default - access grant

            scope.options.parameters = _.sortBy(scope.options.parameters, (param) => param.sequence);
            scope.options.values = _.sortBy(scope.options.values, (value) => value.sortOrder);

            scope.options.parameters.forEach((param) => {
                scope.parameterNames.push(param.name);
            });

            scope.moverHiddenValue;

            scope.now = new Date();
            scope.minDate = new Date(scope.now.getFullYear() - 100, 0, 1);
            scope.startOfTheMonth = new Date(scope.now.getFullYear(), scope.now.getMonth(), 1);
            scope.centralOfficeControl = scope.options.displayName.indexOf('CO') === 0;
            scope.visibilityByControlNames = Object
                .keys(scope.validationJson.ShowIfChecked || {})
                .filter((key) => (scope.validationJson.ShowIfChecked[key] as string[]).indexOf(scope.parameterNames[0]) !== -1)
                .map((controlName: string) => ({ controlName, valueToHide: false }));
            scope.visibilityIfSetArr = [];

            scope.use12HourTimeFormat = this.appSettings.APP_TIME_FORMAT === Meevo.Model.TimeFormatEnum.TimeFormat12;

            const reportHelper: IReportLogic = this.reportLogicFactory.get(scope.selectedReport.shortCut);
            if (reportHelper) {
                scope.properties = reportHelper.properties;

                reportHelper.buildLogic(scope);
            }

            this.applyLabelTranslation(scope);

            if (scope.selectedReport.shortCut === 'MR145') {
                if (scope.parameterNames[0] === 'ProductCategoryMover_TBL') {
                    scope.visibilityByControlNames.push({
                        controlName: 'DisplaySaleForMR145',
                        valueToHide: 'ServiceCategories',
                    });
                }
                if (scope.parameterNames[0] === 'ServiceCategoryMover_TBL') {
                    scope.visibilityByControlNames.push({
                        controlName: 'DisplaySaleForMR145',
                        valueToHide: 'ProductCategories',
                    });
                }
            }

            if (scope.selectedReport.shortCut === 'COMR145') {
                if (scope.parameterNames[0] === 'ProductCategoryMover_TBL') {
                    scope.visibilityByControlNames.push({
                        controlName: 'RunForCOMR145',
                        valueToHide: 50117,
                    });
                }
                if (scope.parameterNames[0] === 'ServiceCategoryMover_TBL') {
                    scope.visibilityByControlNames.push({
                        controlName: 'RunForCOMR145',
                        valueToHide: 50118,
                    });
                }
            }

            if (scope.selectedReport.shortCut === 'AQ010') {
                if (scope.parameterNames[0] === 'EmployeeCategoryList_TBL' || scope.parameterNames[0] === 'EmployeeCList_TBL') {
                    scope.visibilityByControlNames.push({
                        controlName: 'FieldOrderBy',
                        valueToHide: 'Resource'
                    })
                }

                if (scope.parameterNames[0] === 'ResourceCategoryList_TBL' || scope.parameterNames[0] === 'ResourceCList_TBL') {
                    scope.visibilityByControlNames.push({
                        controlName: 'FieldOrderBy',
                        valueToHide: 'Employee'
                    })
                }

                if (scope.parameterNames[0] === 'VisitNotesPerServiceAQ010') {
                    scope.options.values = scope.options.values.map(item => ({ ...item, value: +item.displayName }));
                    scope.visibilityIfSetArr.push({
                        controlName: 'ShowVisitNotes',
                        value: false
                    })
                }
            }

            if (scope.selectedReport.shortCut === 'MR200' && scope.parameterNames[0] === 'ReportSortBy') {
                scope.visibilityIfSetArr.push({
                    controlName: 'RunReportIn',
                    value: 'SummaryView',
                });
            }

            if (scope.selectedReport.shortCut === 'DR020' && scope.parameterNames[0] === 'SortReportByMA215') {
                scope.visibilityIfSetArr.push({
                    controlName: 'viewReportBy',
                    value: 'SummaryView',
                });
            }

            if (scope.selectedReport.shortCut === 'MR120') {
                if (scope.parameterNames[0] === 'OnlyDisplayPackagesWithValueRemaining') {
                    scope.visibilityByControlNames.push({
                        controlName: 'RunReportInMR120',
                        valueToHide: 'SummaryMode',
                        nullValue: false,
                    });
                }
            }

            if (scope.selectedReport.shortCut === 'MR050') {
                if (scope.parameterNames[0] === 'OnlyGiftCardsWithValueRemaining') {
                    scope.visibilityByControlNames.push({
                        controlName: 'RunReportInMR050',
                        valueToHide: 'SummaryMode',
                        nullValue: false,
                    });
                }
            }

            if (scope.selectedReport.shortCut === 'MR160') {
                if (scope.parameterNames[0] === 'PageBreakOnSortOption') {
                    scope.visibilityByControlNames.push({
                        controlName: 'SortBySoldBy',
                        valueToHide: false,
                    });
                }
                if (scope.parameterNames[0] === 'DisplayBundleContents') {
                    scope.visibilityByControlNames.push({
                        controlName: 'DisplayReportInMR160',
                        valueToHide: 'SummaryMode',
                    });
                }
            }

            if (scope.selectedReport.shortCut === 'AQ150' && scope.parameterNames[0] === 'SortReportByAQ150') {
                scope.visibilityByControlNames.push({
                    controlName: 'RunReportInAQ150',
                    valueToHide: 'SummaryView',
                });
            }

            if (scope.selectedReport.shortCut === 'AQ000') {
                if (scope.parameterNames[0] === 'displayPhoneNumber' || scope.parameterNames[0] === 'employeePageBreak') {
                    scope.visibilityByControlNames.push({
                        controlName: 'RunReportInAQ000',
                        valueToHide: 'SummaryMode',
                        nullValue: false,
                    })
                }
            }

            if (scope.selectedReport.shortCut === 'AQ070') {
                if (scope.parameterNames[0] === 'employeePageBreak') {
                    scope.visibilityByControlNames.push({
                        controlName: 'SortReportByAQ070',
                        valueToHide: 'Client',
                        nullValue: false,
                    })
                }
                if (scope.parameterNames[0] === 'EmployeeList_TBL') {
                    scope.visibilityByControlNames.push({
                        controlName: 'SortReportByAQ070',
                        valueToHide: 'Client'
                    })
                }
            }

            if (scope.selectedReport.shortCut === 'DE110' && scope.options.displayName === 'StudentsAndTeachersMover') {
                scope.visibilityByControlNames.push({
                    controlName: 'SortReportByDE110',
                    valueToHide: 50115,
                });
                scope.visibilityIfSetArr.push({
                    controlName: 'SortReportByDE110',
                    value: 50115,
                });
            }

            if (scope.selectedReport.shortCut === 'DP005' && scope.mainModel["ProductListWithLabelCounts_TBL"] != null) {
                scope.selectedReport["customNumberOfLabels"] = true;
            }

            if (scope.selectedReport.shortCut === 'MI215') {
                if (scope.mainModel["DisplRetail"] === undefined && scope.mainModel['DisplShopSupply'] === undefined && scope.mainModel['DisplMiscSupplies'] === undefined) {
                    scope.mainModel['DisplRetail'] = true;
                    scope.mainModel['DisplShopSupply'] = true;
                    scope.mainModel['DisplMiscSupplies'] = true;
                }
                if (scope.mainModel["SortInventorySnapshotReport"] === undefined) {
                    scope.mainModel['SortInventorySnapshotReport'] = 'Manufacturer';
                }
                if (scope.mainModel["OnlyShowProdWithInvActivity"] === undefined) {
                    scope.mainModel['OnlyShowProdWithInvActivity'] = false;
                }
            }

            if (scope.selectedReport.shortCut === 'DB001' && ['DisplayPhoneNumbers', 'DisplaySuspendedMembersOnly', 'DisplayMembersWithErrorsOnly', 'SortReportByDB001'].indexOf(scope.parameterNames[0]) !== -1) {
                scope.visibilityByControlNames.push({
                    controlName: 'RunReportInDB001',
                    valueToHide: 'SummaryMode',
                });
            }

            if (scope.selectedReport.shortCut === 'MA065') {
                if (scope.parameterNames[0] === 'PageBreakOnSortOption') {
                    scope.visibilityByControlNames.push({
                        controlName: 'DisplayDetail',
                        valueToHide: false,
                    });
                }
            }

            if (scope.selectedReport.shortCut === 'MA050') {
                scope.mainModel['ClientVisitsDefinedAsNewToMA050'] = 'Business';
                scope.mainModel['SortReportByMA050'] = 'Employee';

                if (scope.parameterNames[0] === 'DisplayDetailsForAllSelectedEmployees') {
                    scope.visibilityByControlNames.push({
                        controlName: 'viewReportBy',
                        valueToHide: 'SummaryView',
                        nullValue: true
                    });
                }
            }

            //DC65 Open
            if (scope.selectedReport.shortCut === 'DC065') {
                if (scope.parameterNames[0] === 'GroupVisitNotesByLocationDC065') {
                    scope.visibilityByControlNames.push({
                        controlName: 'DisplayVisitNotesByLocationDC065',
                        valueToHide: false,
                        nullValue: false
                    });
                }
            }

            //DC065 consume CO setting
            const isShowVisitNoteForMultipleLocation = this.appSettings.APP_BUSINFOSETTINGS.clientsSettings.showVisitNoteForMultipleLocation;
            const isDisplayVisitNotesByLocationDC065Control = scope.parameterNames[0] === 'DisplayVisitNotesByLocationDC065';
            if (isDisplayVisitNotesByLocationDC065Control && (!isShowVisitNoteForMultipleLocation || this.identityService.isSingleLocation())) {
                element.hide();
            }
            //DC065 consume CO setting
            //DC065 Close

            //DC080
            if (scope.selectedReport.shortCut === 'DC080') {
                scope.mainModel['hideSelectedClientAmount']= true;
            }
            //DC080

            //MA045 Open
            if (scope.selectedReport.shortCut === 'MA045') {
                //MA045 Hide DisplayClientPhoneNumbers control Open
                if (scope.parameterNames[0] === 'DisplayClientPhoneNumbers') {
                    scope.visibilityByControlNames.push({
                        controlName: 'DisplayDetailsForAllSelectedEmployees',
                        valueToHide: false,
                        nullValue: false
                    });
                }
                // MA045 Hide DisplayClientPhoneNumbers control close

                // MA045 Open AnalyzeRetentionForDepartmentMA045
                if (scope.parameterNames[0] === 'Departments_TBL') {
                    scope.mainModel['hideAnalyze'] = false;
                }
                //MA045 Set Up Dropdown Items
                if (scope.parameterNames[0] === 'NumberOfMonths') {
                    let maxDropdownValue = moment().startOf('month').diff(moment(scope.mainModel['MonthYearPickerDate']).startOf('month'), 'month');// Removed +1
                    maxDropdownValue = Math.min(maxDropdownValue, 12);
                    scope.options.values = _.range(1, maxDropdownValue +1)
                        .map((n) => ({ value: n, sortOrder: n, displayName: n.toString() }));
                    scope.mainModel['NumberOfMonths'] = Math.min(3, maxDropdownValue);
                }
            }
            // MA045Close

            //DC042 Open 
            if(scope.selectedReport.shortCut === 'DC042'){
                switch(scope.parameterNames[0]){
                    case 'StartDate':
                    case 'EndDate':
                        scope.visibilityByControlNames.push({
                            controlName:'DisplayClientRestrictionRemovalsDC042',
                            valueToHide:false,
                            nullValue:moment().format()
                        })
                }
            }
            //DC042 Close

            //MI020 Open
            if (scope.selectedReport.shortCut === 'MI020') {
                if (scope.parameterNames[0] === 'DisplayProductCountsWithDifferencesOnlyMI020') {
                    scope.visibilityByControlNames.push({
                        controlName: 'RunReportByMI020',
                        valueToHide: 'SummaryMode',
                        nullValue: false
                    });
                }
            }


            //MI020 Close
            //MI000 Open
            if (scope.selectedReport.shortCut === 'MI000') {
                if (scope.parameterNames[0] === 'employeePageBreak') {
                    scope.visibilityByControlNames.push({
                        controlName: 'GroupByEmployee',
                        valueToHide: false,
                        nullValue: false
                    });
                }
            }
            //MI000 Close

            if (scope.selectedReport.shortCut === 'MR000') {
                switch (scope.parameterNames[0]) {
                    case 'ShowTransactionDetails':
                        scope.visibilityByControlNames.push({
                            controlName: 'DisplayAccountActivityFor',
                            valueToHide: 'ClientsWithExistingBalances',
                            nullValue: false
                        });
                        break;
                    case 'StartDate':
                    case 'EndDate':
                        scope.visibilityByControlNames.push({
                            controlName: 'DisplayAccountActivityFor',
                            valueToHide: 'ClientsWithExistingBalances',
                            nullValue: moment().format()
                        });
                        break;
                    case 'AllClients':
                        scope.mainModel.AllClients = true;
                        scope.visibilityByControlNames.push({
                            controlName: 'DisplayAccountActivityFor',
                            valueToHide: 'ClientsWithExistingBalances',
                            nullValue: true
                        });
                        break;
                    case 'ClientSelector_TBL':
                        scope.visibilityByControlNames.push({
                            controlName: 'DisplayAccountActivityFor',
                            valueToHide: 'ClientsWithExistingBalances'
                        }, {
                            controlName: 'AllClients',
                            valueToHide: true
                        });
                        break;
                    case 'IncludeClientsWithBalancesDue':
                    case 'IncludeClientsWithCreditOwed':
                    case 'DisplayPhoneNumbersMR000':
                        scope.visibilityByControlNames.push({
                            controlName: 'DisplayAccountActivityFor',
                            valueToHide: 'AccountActivityWithinDateRange',
                            nullValue: scope.parameterNames[0] !== 'DisplayPhoneNumbersMR000'
                        });
                        break;
                }
            }

            if (scope.selectedReport.shortCut === 'MR035') {
                scope.moverHiddenValue = SmartMoverHiddenValue.Ids;
                
                switch (scope.parameterNames[0]) {
                    case 'DisplayTransactionNotes':
                        scope.visibilityByControlNames.push({
                            controlName: 'viewReportBy',
                            valueToHide: 'SummaryView',
                            nullValue: false
                        });
                        break;
                    case 'SortReportBySummary':
                        scope.visibilityByControlNames.push({
                            controlName: 'viewReportBy',
                            valueToHide: 'DetailView',
                            nullValue: 'ItemsSold'
                        });
                        break;
                    case 'SortReportByDetail':
                        scope.visibilityByControlNames.push({
                            controlName: 'viewReportBy',
                            valueToHide: 'SummaryView',
                            nullValue: 'Date'
                        });
                        break;
                    case 'ServiceCategoryMover_TBL':
                        scope.visibilityByControlNames.push({
                            controlName: 'DisplayServices',
                            valueToHide: false
                        });
                        break;
                    case 'ProductCategoryMover_TBL':
                    case 'ManufacturerMover_TBL':
                        scope.visibilityByControlNames.push({
                            controlName: 'DisplayProducts',
                            valueToHide: false
                        });
                        break;
                    case 'LiabilitiesMover_TBL':
                        scope.visibilityByControlNames.push({
                            controlName: 'DisplayLiabilities',
                            valueToHide: false
                        })
                }
            }

            if (scope.selectedReport.shortCut === 'MR041') {
                if (scope.parameterNames[0] === 'SortGraphDataByMR041') {
                    scope.visibilityByControlNames.push({
                        controlName: 'DisplayGraphsMR041',
                        valueToHide: false,
                        nullValue: 'SalesRanking'
                    });
                }
            }

            //MR085
            if (scope.selectedReport.shortCut === 'MR085') {
                if (scope.parameterNames[0] === 'ProductCategoryMover_TBL') {
                    scope.visibilityByControlNames.push({
                        controlName: 'ShowRetailSection',
                        valueToHide: false,
                        nullValue: null
                    });
                }
                else if (scope.parameterNames[0] === 'ServiceCategoryMover_TBL') {
                    scope.visibilityByControlNames.push({
                        controlName: 'ShowServiceSection',
                        valueToHide: false,
                        nullValue: null
                    });
                }
            }

            if (scope.selectedReport.shortCut === 'MR255') {
                if (scope.parameterNames[0] === 'DisplayDetailMR255') {
                    scope.visibilityByControlNames.push({
                        controlName: 'SortReportByMR255',
                        valueToHide: 'ServiceCharge',
                        nullValue: false
                    });
                } else if (scope.parameterNames[0] === 'PageBreakOnEmployee') {
                    scope.visibilityByControlNames.push({
                        controlName: 'SortReportByMR255',
                        valueToHide: 'ServiceCharge',
                        nullValue: false
                    }, {
                        controlName: 'SortReportByMR255',
                        valueToHide: 'Service',
                        nullValue: false
                    }, {
                        controlName: 'DisplayDetailMR255',
                        valueToHide: false,
                        nullValue: false
                    });
                }
            }

            if (scope.selectedReport.shortCut === 'MR260') {
                if (scope.parameterNames[0] === 'DisplayGraphForMR260') {
                    scope.visibilityByControlNames.push({
                        controlName: 'DisplaySalesForMR260',
                        valueToHide: 'TotalSales',
                        nullValue: 'Sales'
                    })
                }
            }

            if (scope.selectedReport.shortCut === 'COMR140') {
                if (scope.parameterNames[0] === 'SortReportByCOMR140') {
                    // set default item for dropdown menu
                    scope.mainModel[scope.parameterNames[0]] = 'TotalSales';
                }
            }

            if (scope.selectedReport.shortCut === 'AQ010') {
                if (scope.parameterNames[0] === 'DisplayVisitNotesLocations') {
                    if (this.appSettings.APP_BUSINFOSETTINGS.clientsSettings.showVisitNoteForMultipleLocation && !this.identityService.isSingleLocation()) {
                        scope.visibilityByControlNames.push({
                            controlName: 'ShowVisitNotes',
                            valueToHide: false,
                            nullValue: false
                        });
                    } else {
                        element.hide();
                    }
                }
            }

            if (scope.selectedReport.shortCut === 'DE040') {
                switch (scope.parameterNames[0]) {
                    case 'DisplayWeeklyBreakdowns':
                    case 'ViewPayrollDataFor':
                        scope.visibilityByControlNames.push({
                            controlName: 'RunEmployeeCompensationReportInMode',
                            valueToHide: 'DetailView',
                            nullValue: false
                        });
                        break;
                    case 'StartDate':
                    case 'EndDate':
                        scope.visibilityByControlNames.push({
                            controlName: 'ViewPayrollDataFor',
                            valueToHide: 'OnePayrollPeriod',
                            nullValue: moment().format()
                        });
                        break;
                }
            }

            if (scope.selectedReport.shortCut === 'MR061' && scope.options.reportControlEnumType === 50017) {
                for (let i = 0; i <= 5; i++) {
                    scope.options.values[i] = {
                        value: moment().year() - i,
                        displayName: `${moment().year() - i}`,
                        sortOrder: i + 1
                    }
                }
            }

            if (scope.selectedReport.shortCut === 'MR126') {
                switch (scope.parameterNames[0]) {
                    case 'ClientSelector_TBL':
                        scope.visibilityByControlNames.push({
                            controlName: 'AllClients',
                            valueToHide: true
                        });
                        break;
                    case 'LiabilitiesMover':
                        scope.options.values = scope.options.values.filter(item => item.value !== 'ClientAccount')
                }
            }

            if (this.identityService.isSingleLocation() && scope.options.displayName === 'DisplayAppointmentsForClientsAtAllLocationsCheckbox') {
                element.hide();
            }

            const showTransactionHistoryForMultipleLocation = this.appSettings.APP_BUSINFOSETTINGS.clientsSettings.showTransactionHistoryForMultipleLocation;
            const isTransactionsFromAllLocationsControl = scope.parameterNames[0] === 'TransactionsFromAllLocations';
            if (isTransactionsFromAllLocationsControl && (!showTransactionHistoryForMultipleLocation || this.identityService.isSingleLocation())) {
                element.hide();
            }

            this.setDefaultValue(scope);

            // OPEN hide phone number checkbox when countryId is not en-us
            //const phoneNumberControls=[
            //    'displayPhoneNumber',
            //    'DisplayPhoneNumbers',
            //    'DisplayPhoneNumbersMR000',
            //    'DisplayClientPhoneNumbers'
            //];
            //if(phoneNumberControls.indexOf(scope.parameterNames[0]) >-1 ){
            //    if(this.appSettings.APP_COUNTRYID.toLowerCase()!== 'en-us'){
            //        element.hide();
            //        scope.mainModel[scope.parameterNames[0]]=false;
            //    }
            //}
            //Close Hide displayPhoneNumbers control for NON US Countries

            scope.atLeastOneCheckbox = () => {
                let requeredField = false;

                if (scope.validationJson.AtLeastOneCheckbox) {
                    _.each(scope.validationJson.AtLeastOneCheckbox, (item) => {
                        if (requeredField === false && scope.mainModel != null) {
                            requeredField = scope.mainModel[item] === true;
                        }
                    });
                }
                return requeredField;
            };

            scope.showIfChecked = () => {
                for (const row of scope.visibilityByControlNames) {
                    if (scope.mainModel[row.controlName] === row.valueToHide) {
                        return false;
                    }
                }

                for (const item of scope.visibilityIfSetArr) {
                    if (scope.mainModel[item.controlName] === item.value) {
                        return false;
                    }
                }

                return true;
            };

            if (scope.options.securityKey) {
                this.securityService.checkSecurityKey(scope.options.securityKey)
                    .then((permission: SecurityAccessEnum) => {
                        scope.securityAccess = permission;

                        this.render(scope, element);
                    })
                    .catch(() => this.render(scope, element));
            } else {
                this.render(scope, element);
            }

            scope.friendlyReminder = () => {
                if (scope.securityAccess !== SecurityAccessEnum.Grant) {
                    this.modalService.alert('LABEL_REPORT_CONTROL_ACCESS_DENIED', Components.Modal.ModalTranslationModes.Translate);
                }
            };

            scope.locationId = this.identityService.locationId;

            let splitString = ' X ';
            let labelSplit = scope.options.labelText?scope.options.labelText.indexOf(splitString):-1;

            if (labelSplit > 0) {
                scope.mainModel['LabelBegins'] = scope.options.labelText.substring(0, labelSplit);
                scope.mainModel['LabelEnds'] = scope.options.labelText.substring(labelSplit + splitString.length)
            }

            // This should be the last function call in the class declaration
            this.setWatchers(scope, element);
        };

        /**
         * Apply label translation
         * @param {IReportControlScope} scope - directive's scope
         * */
        applyLabelTranslation(scope: IReportControlScope): void {
            // Check if there is a label for the control by transforming the labelText value of
            // the control as defined in [rpt].[ReportControl_S] according to the following rules:
            // 1. Remove any character that is not a letter, number, or space
            // 2. Replace spaces with underscores
            // 3. Capitalize all characters
            // This creates a key (e.g., "Display Detail(s)" becomes "LABEL_DISPLAY_DETAILS") which
            // is used to check for a translation.

            if (!scope.options || !scope.options.labelText) return;

            var key = `LABEL_${scope.options.labelText.replace(/[^a-zA-Z0-9\s]/g, '').replace(/\s+/g, '_').toUpperCase()}`;
            var translation = this.$translate.instant(key);

            if (translation && translation.indexOf('LABEL_') !== 0) {
                scope.options.labelText = translation;
            }
        }

        /**
         * Set default values
         * @param {IReportControlScope} scope - directive's scope
         * */
        setDefaultValue(scope: IReportControlScope): void {
            switch (scope.options.reportControlEnumType) {
                case 50006:
                    scope.mainModel[scope.parameterNames[0]] = scope.options.values[0].value;
                    break;
            }

            switch (scope.options.displayName) {
                case 'LocationBreakCheckbox':
                case 'CombineTotalsForAllLocations':
                case 'ShowVisitNotesCheckbox':
                    if (scope.mainModel[scope.parameterNames[0]] == null)
                        scope.mainModel[scope.parameterNames[0]] = true;
                    break;
                case 'Checkbox':
                    let hasCheckedByDefault = scope.validationJson && Array.isArray(scope.validationJson.CheckedByDefault) && scope.mainModel[scope.parameterNames[0]] != false;
                    if (hasCheckedByDefault && scope.validationJson.CheckedByDefault.indexOf(scope.parameterNames[0]) > -1) {
                        scope.mainModel[scope.parameterNames[0]] = true;
                    }
                    break;
                case 'PurchaseOrderMovers':
                    scope.criteria = new Mi100Criteria(scope).criteria;
                    break;
                case 'DepartmentServiceCatMover':
                    scope.criteria = new Ma075Criteria(scope).criteria;
                    break;
                case 'PointsPromotionsMover':
                    scope.criteria = {};
                    break;
                case 'DepartmentListEmployeeMover':
                    scope.criteria = new Ma045Criteria(scope).criteria;
                    break;
                case 'StudentsAndTeachersMover':
                    if (scope.selectedReport.shortCut === 'DE110') {
                        scope.criteria = new De110Criteria(scope).criteria;
                    }
                    break;
                case 'ClientSelectorCkbox':
                    if (scope.selectedReport.shortCut === 'DC080'
                        && scope.selectedReport.customData
                        && scope.selectedReport.customData.clientIds) {
                        scope.mainModel[scope.parameterNames[0]] = scope.selectedReport.customData.clientIds
                    }
                    break;
                case 'ClientSelector':
                    if (['MR205', 'MR126'].indexOf(scope.selectedReport.shortCut) > -1) {
                        // show 'All clients' checkbox and set it to checked
                        scope.isAllClientsVisible = true;
                        scope.allClients = true;
                    }
                    break;
                case 'DateRangeYear':
                    scope.options['hideDatePickers'] = "true";

                    if (scope.selectedReport.shortCut === 'MA201') {
                        scope.options['presetList'] = [
                            { name: 'LABEL_LAST_TWELVE_MONTHS_AND_CURRENT_MONTH', status: PresetStatus.LastThirteenMonths },
                            { name: 'LABEL_CURRENT_YEAR', status: PresetStatus.ThisYear },
                            { name: 'LABEL_LAST_YEAR', status: PresetStatus.LastYear },
                            { name: 'LABEL_SELECTED_YEAR', status: PresetStatus.SpecificYear },
                        ];
                    } else {
                        scope.options['presetList'] = [
                            { name: 'LABEL_LAST_THIRTEEN_MONTHS', status: PresetStatus.LastThirteenMonths },
                            { name: 'LABEL_LAST_YEAR', status: PresetStatus.LastYear },
                            { name: 'LABEL_SPECIFIC_YEAR', status: PresetStatus.SpecificYear },
                        ];
                    }
                    scope.mainModel['selectedYear'] = scope.selectedReport.shortCut === 'MA201' ? moment().subtract(2, 'years').year() : moment().year();

                    break;
                case 'ReportDateRangeBasedOn':
                    scope.mainModel['ReportDateRangeBasedOn'] = ReportDateRangeBasedOnEnum.DateServiceCreatedOn;
                    break;
                case 'EmployeeTeacherStudentMover':
                    this.securityService.checkModuleAccess(
                        Meevo.Components.Common.SecurityKeys.DATA_STUDENTTEACHERMODULE +
                        Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    ).then(response => {
                        // check if student/teacher module is enabled
                        if (response === Model.SecurityAccessEnum.Grant) {
                            scope.mainModel[scope.parameterNames[0]] = true;
                            Object.keys(scope.smartMoverLabelKeys).forEach(employeeType => {
                                scope.smartMoverLabelKeys[employeeType].validationMessage = 
                                    'LABEL_SELECT_AT_LEAST_ONE_EMPLOYEE_STUDENT_TEACHER';
                            });
                        } else {
                            scope.mainModel[scope.parameterNames[0]] = false;
                            // set allSelected to false for student/teacher movers
                            scope.mainModel[scope.parameterNames[3]] = false;
                            scope.mainModel[scope.parameterNames[5]] = false;
                            scope.mainModel[scope.parameterNames[7]] = false;
                        }
                    });
                    scope.smartMoverLabelKeys = {
                        'employees': buildSmartMoverLabelKeys('EMPLOYEES'),
                        'students': buildSmartMoverLabelKeys('STUDENTS'),
                        'teachers': buildSmartMoverLabelKeys('TEACHERS'),
                        'teachersAssisting': buildSmartMoverLabelKeys('TEACHERS_ASSISTING')
                    }
                    break;
                case 'MerchantAccountMover':
                    scope.criteria = {
                        includeActive: true,
                        includeInactive: true,
                        includeDeleted: true
                    }
                    break;
                case 'Hierarchy':
                case 'COEmployeeClassificationMover':
                case 'COEmployeeClassificationMoverWithoutEmployee':
                case 'COEmployeeMover':
                case 'COServiceMover':
                case 'COServiceMoverWithEmployee':
                    this.securityService.checkModuleAccess(
                        Meevo.Components.Common.SecurityKeys.DATA_BUSINESSTYPE +
                        Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    ).then(response => scope.isBusinessTypesModuleEnabled = response === Model.SecurityAccessEnum.Grant);
                    break;
            }

            function buildSmartMoverLabelKeys(employeeType: string) {
                return {
                    title: `LABEL_ALL_${employeeType}_UPPER`,
                    allSelectedLabel: `LABEL_ALL_${employeeType}_UPPER`,
                    totalSelectedMessage: `LABEL_TOTAL_${employeeType}_SELECTED`,
                    validationMessage: 'LABEL_REPORTS_SELECT_AT_LEAST_ONE_EMPL',
                    filterLabel: `LABEL_HIDE_INACTIVE_${employeeType}_UPPER`
                }
            }

            if (['MR080', 'MR085', 'MR100', 'MR110', 'MR115', 'DE070'].indexOf(scope.selectedReport.shortCut) !== -1) {
                if (scope.mainModel != null && scope.mainModel['DrawerMover_TBL'] && !!scope.mainModel['DrawerMover_TBL'].length && scope.mainModel.isDrawerAllSelected) {
                    scope.mainModel.isDrawerAllSelected = false;
                }
                Object.defineProperty(scope, 'openCloseHistoryModel', {
                    get: () => {
                        if (scope.mainModel != null)
                            return scope.mainModel['DrawerMover_TBL'] || (scope.mainModel['DrawerMover_TBL'] = []);
                        else
                            return null;
                    }
                });
                Object.defineProperty(scope, 'openCloseHistoryKey', {
                    get: () => 'drawer_TId'
                });

                scope.$on('openCloseHistoryModelValueSet', () => {
                    scope.mainModel['CombineDrawerTotals'] = false;
                });

                scope.mr080ShowSeconds = true;
            }

            if (scope.selectedReport.shortCut === 'MR100') {
                if (scope.options.displayName === 'EmployeeMover') {
                    scope.employeeMoverCheckBoxContentKey = 'LABEL_ALL_CREDITED_EMPLOYEE';
                }
            }
        }

        /**
         * Set watchers
         * @param {IReportControlScope} scope - directive's scope
         * */
        setWatchers(scope: IReportControlScope, element: JQuery): void {
            // set NULL values to the controls that we need to hide
            const controlValues = [];
            scope.visibilityByControlNames.forEach((row) => {
                if (row.nullValue === undefined) {
                    row.nullValue = null;
                }

                scope.$watch(() => scope.mainModel[row.controlName], (newValue: any, oldValue: any) => {
                    if (newValue === oldValue) return;

                    if (scope.mainModel[row.controlName] === row.valueToHide) {
                        for (const key of scope.parameterNames) {
                            controlValues[key] = scope.mainModel[key];
                            this.$timeout(() => scope.mainModel[key] = row.nullValue);
                        }
                    } else if (scope.mainModel[scope.parameterNames[0]] === null) {
                        this.$timeout(() => {
                            for (const key of scope.parameterNames) {
                                scope.mainModel[key] = controlValues[key];
                            }
                        });
                    }
                    //Force Controls to be re-compiled for Save / Load Functionality In Data Maintenance Forms
                    else if (scope.mainModel[row.controlName] != row.valueToHide && !this.isRendered) {
                        this.render(scope, element);
                    }

                });
            });

            if (scope.selectedReport.shortCut === 'AQ225') {
                if (scope.options.id === 79) {
                    const allValues = angular.copy(scope.options.values);
                    const values = allValues.filter((v) => v.value !== 'Resource');
                    const valuesForUnassignedAppointments = allValues.filter((v) => v.value !== 'Employee');

                    scope.options.values = angular.copy(values);

                    scope.$watch(() => scope.mainModel['FilterApptsTo'], (newValue: string, oldValue: string) => {
                        if (newValue === 'UnassignedAppointments') {
                            scope.options.values = valuesForUnassignedAppointments;
                            if (scope.mainModel['SortReportByAQ246'] === 'Employee') {
                                scope.mainModel['SortReportByAQ246'] = scope.options.values[0].value;
                            }
                        } else if (oldValue === 'UnassignedAppointments') {
                            scope.options.values = angular.copy(values);
    
                            if (scope.mainModel['SortReportByAQ246'] === 'Resource') {
                                scope.mainModel['SortReportByAQ246'] = scope.options.values[0].value;
                            }
                        }
                    });
                }

                if (scope.options.id === 108) {
                    const allItems = angular.copy(scope.options.values);
                    const itemsWithoutAll = allItems.filter((v) => v.value !== 'All');

                    scope.$watch(() => scope.mainModel['AppointmentCategory'], (newValue: any) => {
                        if (newValue && newValue.id) {
                            scope.options.values = angular.copy(allItems);
                            scope.mainModel['FilterApptsTo'] = 'All';
                        } else {
                            scope.options.values = angular.copy(itemsWithoutAll);
                            if (scope.mainModel['FilterApptsTo'] === 'All') {
                                scope.mainModel['FilterApptsTo'] = 'AppointmentsBookedOnline';
                            }
                        }
                    });
                }
            }

            switch (scope.options.displayName) {
                case 'InventoryCountSheetsSortMovers':
                    scope.$watch(() => scope.mainModel[scope.parameterNames[0]], () => {
                        (scope.mainModel[scope.parameterNames[3]] || []).length = 0;
                    });
                    break;
            }

            if (scope.selectedReport.shortCut === 'MA045' && scope.parameterNames[0] === 'NumberOfMonths') {
                scope.$watch(() => scope.mainModel['MonthYearPickerDate'], (value: Date) => {
                    const monthsInYear = 12;
                    let maxDropdownValue = moment().startOf('month').diff(moment(value).startOf('month'), 'month'); // erased "+1"
                    maxDropdownValue = Math.min(maxDropdownValue, monthsInYear);
                    scope.options.values = _.range(1, maxDropdownValue +1 )
                        .map((n) => ({ value: n, sortOrder: n, displayName: n.toString() }));
                    scope.mainModel['NumberOfMonths'] = Math.min(3, maxDropdownValue);
                });
            }

            if (scope.selectedReport.shortCut === 'DC065' && scope.options.reportId === 3) {
                scope.$watch(() => scope.mainModel['isAllClientChecked'], (newAllClientValue: string, oldAllClientValue: string) => {
                    if (newAllClientValue) {
                        scope.validationJson.LimitDateRangeTo = "1Week";
                    } else
                        scope.validationJson.LimitDateRangeTo = "1Years";
                });
            }

            if (scope.selectedReport.shortCut === 'DB040') {
                scope.$watch(() => {
                    if (scope.mainModel['DisplayEFTInfoFor'] === 'PaymentPlans') {
                        scope.validationJson.RunReportFor = 'PastToday';
                    } else {
                        scope.validationJson.RunReportFor = 'All';
                    }
                })
                if (scope.parameterNames[0] === 'DisplayEFTInfoFor') {
                    scope.$watch(() => scope.mainModel[scope.parameterNames[0]], (value) => {
                        if (value === 'PaymentPlans') {
                            scope.mainModel['EndDate'] = new Date();
                        }
                    });
                }
                if (scope.options.displayName === 'DateRange') {
                    scope.$watch(() => scope.mainModel['EndDate'], (value) => {
                        if (scope.mainModel['DisplayEFTInfoFor'] === 'PaymentPlans' && value > new Date()) {
                            scope.mainModel['EndDate'] = new Date();
                        }
                    });
                }
            }

            if (['MR120', 'MR050'].indexOf(scope.selectedReport.shortCut) > -1) {
                if (scope.options.id === 374) {
                    // referral parameters need to be assigned from mover table
                    const includeClients = scope.parameterNames[0];
                    const includeEmployees = scope.parameterNames[1];

                    scope.$watch(() => {
                        // check for clients
                        const referrals = scope.mainModel['ReferralTypeMover_TBL'];
                        if (!referrals) return false;
                        return referrals.some((id: string) => id.match(/0{8}-0000-0000-000c-\d+/));
                    }, newValue => scope.mainModel[includeClients] = newValue);

                    scope.$watch(() => {
                        // check for employees
                        const referrals = scope.mainModel['ReferralTypeMover_TBL'];
                        if (!referrals) return false;
                        return referrals.some((id: string) => id.match(/0{8}-0000-0000-000e-\d+/));
                    }, newValue => scope.mainModel[includeEmployees] = newValue);
                }
            }

            if (scope.selectedReport.shortCut === 'MR035' && scope.options.id === 380) {
                // liability parameters need to be assigned from mover table
                const includeGiftCards = scope.parameterNames[1];
                const includeMemberships = scope.parameterNames[2];
                const includePackages = scope.parameterNames[3]

                scope.$watch(() => {
                    const liabilities = scope.mainModel['LiabilitiesMover_TBL'];
                    if (!liabilities) return false;
                    return liabilities.indexOf(Model.LiabilitiesMR035Enum.GiftCards) > -1
                }, newValue => scope.mainModel[includeGiftCards] = newValue);

                scope.$watch(() => {
                    const liabilities = scope.mainModel['LiabilitiesMover_TBL'];
                    if (!liabilities) return false;
                    return liabilities.indexOf(Model.LiabilitiesMR035Enum.Memberships) > -1
                }, newValue => scope.mainModel[includeMemberships] = newValue);

                scope.$watch(() => {
                    const liabilities = scope.mainModel['LiabilitiesMover_TBL'];
                    if (!liabilities) return false;
                    return liabilities.indexOf(Model.LiabilitiesMR035Enum.Packages) > -1
                }, newValue => scope.mainModel[includePackages] = newValue);
            }

            if (scope.selectedReport.shortCut === 'MR130' && scope.parameterNames[0] === 'RunReportModeMR130') {
                scope.$watch(() => scope.mainModel[scope.parameterNames[0]], (newValue, currentValue) => {
                    if (newValue !== currentValue && newValue === 'BreakDownByDay') {
                        scope.mainModel[scope.parameterNames[1]] = null;
                    }
                });
            }
				
            if (
                scope.validationJson.DateRangeLimitByControl &&
                scope.validationJson.DateRangeLimitByControl.length > 1 &&
                scope.parameterNames[0] === scope.validationJson.DateRangeLimitByControl[0]
            ) {
                // create a watcher to set the date range limit dynamically based on another control                
                const controlToWatch = scope.validationJson.DateRangeLimitByControl[0];
                const dateLimitsByValue = scope.validationJson.DateRangeLimitByControl[1];
                const runReportForsByValue = scope.validationJson.DateRangeLimitByControl[2] || {};

                scope.$watch(() => scope.mainModel[controlToWatch], (value: string) => {
                    if (runReportForsByValue.hasOwnProperty(value)) {
                        scope.validationJson.RunReportFor = runReportForsByValue[value];
                    }
                    if (dateLimitsByValue.hasOwnProperty(value)) {
                        scope.validationJson.LimitDateRangeTo = dateLimitsByValue[value];
                    }
                });
            }
        }

        /**
         * Get and render template
         * @param {IReportControlScope} scope - directive's scope
         * @param {JQuery} element - directive's element
         * */
        render(scope: IReportControlScope, element: JQuery): void {
            const { displayName } = scope.options;

            if (!scope.isRendered) {
                this.$templateRequest(`${this.templateBaseUrl}${displayName}.html`).then((template) => {
                    let div = angular.element('<div ng-hide="((securityAccess === securityAccessEnum.Hide) && !centralOfficeControl) || !showIfChecked()"></div>');

                    div = this.$compile(div)(scope);
                    div.append(this.$compile(template)(scope));

                    element.append(div);

                    scope.isRendered = true;
                });
            }
        }


        static factory(): angular.IDirectiveFactory {
            let directive = (
                $compile: angular.ICompileService,
                $timeout: angular.ITimeoutService,
                $templateRequest: angular.ITemplateRequestService,
                securityService: Meevo.Components.Common.ISecurityService,
                modalService: Meevo.Components.Modal.IModalService,
                identityService: Meevo.Components.Common.IIdentityService,
                appSettings: Meevo.Components.Common.IAppSettings,
                reportLogicFactory: IReportLogicFactory,
                $translate: angular.translate.ITranslateService,
            ) => {
                return new ReportControl(
                    $compile,
                    $timeout,
                    $templateRequest,
                    securityService,
                    modalService,
                    identityService,
                    appSettings,
                    reportLogicFactory,
                    $translate,
                );
            };

            directive.$inject = [
                '$compile',
                '$timeout',
                '$templateRequest',
                'meevo.components.common.SecurityService',
                'meevo.components.modal.ModalService',
                'meevo.components.common.IdentityService',
                'meevo.AppSettings',
                'meevo.components.controls.ReportLogicFactory',
                '$translate',
            ];

            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoReportControl', ReportControl.factory());
}
